import { getData } from '../../../common/utils/network.utils';

export const fetchVerifiedCommunities = async () => {
    return (await getData('communities/verified')).data;
}

export const searchVerifiedCommunities = async (searchTerm) => {
    return (await getData(`communities/search?searchTerm=${searchTerm}`)).data;
}